<script lang="ts">
  import type { EasyJetPlusAnswer } from "../types";

  let {
    url,
    status,
  }: {
    url: string | null | undefined;
    status: EasyJetPlusAnswer;
  } = $props();
</script>
{#if url || (status === "claimed")}
  <h3 class="ui-section-title">easyJet Plus included in your settlement</h3>

  <p class="mb-8">
    A year of easyJet Plus normally costs £249.
    {#if status === "claimed"}
      You’ve already claimed your free year!
    {:else if status === "declined"}
      You’ve declined, but you can <a href={url} class="underline text-primary" data-turbo-frame="task-modal">change your mind</a> until 11 December 2026.
    {:else}
      <a href={url} class="underline text-primary" data-turbo-frame="task-modal">Claim your free year</a>.
    {/if}
  </p>
{/if}